"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var FirstPage_1 = __importDefault(require("@mui/icons-material/FirstPage"));
var KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
var LastPage_1 = __importDefault(require("@mui/icons-material/LastPage"));
function TablePaginationActions(props) {
    var count = props.count, page = props.page, rowsPerPage = props.rowsPerPage, onPageChange = props.onPageChange;
    var theme = (0, material_1.useTheme)();
    var handleFirstPageButtonClick = function (event) {
        onPageChange(event, 0);
    };
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (react_1.default.createElement(material_1.Box, { flexShrink: 0, marginLeft: theme.spacing(2.5) },
        react_1.default.createElement(material_1.IconButton, { onClick: handleFirstPageButtonClick, disabled: page === 0, "aria-label": "first page" },
            react_1.default.createElement(FirstPage_1.default, null)),
        react_1.default.createElement(material_1.IconButton, { onClick: handleBackButtonClick, disabled: page === 0, "aria-label": "previous page" },
            react_1.default.createElement(KeyboardArrowLeft_1.default, null)),
        react_1.default.createElement(material_1.IconButton, { onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "next page" },
            react_1.default.createElement(KeyboardArrowRight_1.default, null)),
        react_1.default.createElement(material_1.IconButton, { onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage) - 1, "aria-label": "last page" },
            react_1.default.createElement(LastPage_1.default, null))));
}
exports.default = TablePaginationActions;
